export default "__VITE_ASSET__DQ56vZNb__"